export default __webpack_public_path__ + "static/media/hubspot.1dd52500.png";